import decamelizeKeys from 'decamelize-keys'

const QUERY_EXCLUDED_KEYS = ['pageSize'] as const

export function toQueryString(params: Record<string, unknown>): string {
  const snakeCased = decamelizeKeys(params as Record<string, string>, {
    deep: false,
    exclude: [...QUERY_EXCLUDED_KEYS],
  }) as Record<string, unknown>

  const entries = Object.entries(snakeCased)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => [k, String(v)])

  return new URLSearchParams(entries).toString()
}

export const GW = {
  packaging: (path: string) => `${import.meta.env.VITE_PATH_PACKAGING}${path}`,
  iam: (path: string) => `${import.meta.env.VITE_PATH_IAM}${path}`,
  masterdata: (path: string) => `${import.meta.env.VITE_PATH_MASTERDATA}${path}`,
} as const

function trimLeadingSlashes(value: string): string {
  return value.replace(/^\/+/, '')
}

/**
 * Tests whether a request URL points at a given `GW`-built path.
 *
 * `GW.*` yields slash-less paths (`api/v1/iam/auth/login`, since `VITE_PATH_*` has no
 * leading `/`) while hand-written URLs and axios configs often carry one. Comparing the
 * raw strings makes interceptor checks silently miss, so both sides are trimmed first.
 *
 * @param requestUrl - URL taken from the axios request config.
 * @param gatewayPath - Path produced by one of the `GW` builders.
 */
export function matchesGatewayPath(requestUrl: string, gatewayPath: string): boolean {
  return trimLeadingSlashes(requestUrl).includes(trimLeadingSlashes(gatewayPath))
}
